import { GoabCallout } from "@abgov/react-components";

export const InPersonPayment = () => {
  return (
    <>
      <GoabCallout type="important" heading="Opting out of e-Transfer">
        You will be asked to visit an{" "}
        <u>
          <a href="https://www.alberta.ca/alberta-supports">Alberta Supports Centre</a>
        </u>
        {" "}in-person to receive your payment, if eligible.
      </GoabCallout>
    </>
  );
};
